import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	getList(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `playlist`;
		return this.http.get(api, options);
	}


	savePlaylist(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `playlist`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	updatePlaylist(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `playlist/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	addToPlaylist(params: any, resourceID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `playlist/${resourceID}/add`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}
}
